// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 818) return "static/css/client.513d63c5.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "d7ead883" + ".chunk.css";
};